import { useState } from "react";

export default function AdminTrustScorePage() {

    const [score] = useState({
        trust: 94,
        security: 98,
        blockchain: 100,
        ai: 96,
        iot: 91,
        route: 95,
        risk: 4,
    });

    return (
        <div style={{ padding: 20 }}>
            <h2>Trust Score Engine</h2>

            <p>
                Intelligent shipment trust evaluation.
            </p>

            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
                gap: 20
            }}>

                <Card title="Trust Score" value={`${score.trust}/100`} color="#2E7D32" />

                <Card title="Security Score" value={`${score.security}/100`} color="#1565C0" />

                <Card title="Blockchain Integrity" value={`${score.blockchain}%`} color="#6A1B9A" />

                <Card title="AI Confidence" value={`${score.ai}%`} color="#EF6C00" />

                <Card title="IoT Reliability" value={`${score.iot}%`} color="#00897B" />

                <Card title="Route Reliability" value={`${score.route}%`} color="#3949AB" />

                <Card title="Risk Level" value={`${score.risk}%`} color="#C62828" />

            </div>

        </div>
    );
}

function Card({ title, value, color }) {

    return (
        <div style={{
            background: "white",
            borderLeft: `8px solid ${color}`,
            borderRadius: 12,
            padding: 20,
            boxShadow: "0 3px 10px rgba(0,0,0,.1)"
        }}>

            <div style={{
                color: "#666",
                fontSize: 15
            }}>
                {title}
            </div>

            <div style={{
                fontSize: 34,
                fontWeight: "bold",
                marginTop: 10
            }}>
                {value}
            </div>

        </div>
    );
}